const TermsAndConditions = () => {
  return (
    <div className="content-page">
      <div className="mb-4">
        <i className="fa-sharp fa-solid fa-file font-xl mr-11" />
        <span className="page-title ng-scope">Terms and conditions</span>
      </div>
      <p>
        <strong>Effective 4 September 2026</strong>
      </p>
      <p>
        These Terms govern use of the iCompete Natural website and portal,
        member conduct and content, and the purchase and holding of ICN
        membership. They include ICN's Code of Ethics and online safety
        standards. Competition entry is a separate application and membership
        does not guarantee eligibility or acceptance into an event.
      </p>
      <h3>1. Who we are</h3>
      <p>
        The iCompete Natural website, members portal and membership services are
        operated by Natural Icons Pty. Ltd. (ABN 52 089 094 351), trading as
        iCompete Natural. In these Terms, “ICN”, “we”, “us” and “our” refer to
        Natural Icons Pty. Ltd., and “you” and “member” refer to the person
        using the portal or holding an ICN membership.
      </p>
      <p>
        In these Terms, “portal” includes the ICN website, members portal and
        related digital functions. “Content” includes profiles, photographs,
        posts, messages, event information, results, status icons, documents and
        other material made available through the portal.
      </p>
      <h3>2. Acceptance of these Terms</h3>
      <p>
        You agree to these Terms when you create an account, purchase or renew a
        membership, select the acceptance box, or continue using the portal
        after the Terms have been presented to you. These Terms should be read
        together with the ICN Rules &amp; Regulations, Eligibility Rule,
        Anti-Doping Policy, Privacy Policy and any specific terms displayed for
        an event or purchase.
      </p>
      <p>
        If you are under 18 years of age, a parent or legal guardian must
        approve your membership, these Terms and your participation in ICN
        activities. Premium membership and competition are available from 15
        years of age, subject to the applicable division, event and local-law
        requirements.
      </p>
      <h3>3. Your account</h3>
      <p>
        You must provide accurate and current information, maintain only one
        personal account, and promptly update any change to your contact
        details. Membership and account access are personal and must not be
        transferred, shared or used by another person.
      </p>
      <p>
        You are responsible for keeping your login credentials secure and for
        activity conducted through your account. You must notify ICN promptly if
        you suspect unauthorised access. ICN may require reasonable identity
        verification before changing account details or processing a sensitive
        request.
      </p>
      <h3>4. Premium Membership</h3>
      <p>
        <strong>Membership period.</strong> A Premium Membership runs for 365
        days from the date successful payment is recorded, unless it is
        suspended or terminated under these Terms.
      </p>
      <p>
        <strong>What membership provides.</strong> Membership provides access to
        the member benefits and portal functions described at the time of
        purchase. Competition entry fees, photography, merchandise, travel and
        other event-related purchases are not included unless expressly stated.
      </p>
      <p>
        <strong>No guarantee of competition eligibility.</strong> Membership
        allows a person to be part of ICN but does not confirm that the person
        is eligible to compete, guarantee acceptance of an entry application, or
        guarantee access to a particular event, division, benefit or service.
      </p>
      <p>
        <strong>Personal membership.</strong> Membership has no cash value, is
        not transferable and may not be resold or assigned.
      </p>
      <h3>5. Fees and payment</h3>
      <p>
        The membership price, currency, applicable taxes and available payment
        method will be displayed before payment. By submitting payment, you
        confirm that you are authorised to use the selected payment method and
        authorise ICN and its payment provider to process the transaction.
      </p>
      <p>
        Banks and payment providers may impose their own currency-conversion or
        transaction charges. ICN is not responsible for charges imposed
        independently by those providers. A membership begins only after payment
        is successfully completed.
      </p>
      <h3>6. One-time payment and automatic renewal</h3>
      <p>
        <strong>One-time membership.</strong> If you select one-time payment,
        the membership expires at the end of its 365-day period and no further
        membership payment will be taken automatically.
      </p>
      <p>
        <strong>Automatic renewal.</strong> Where automatic renewal is offered
        and selected, you authorise ICN and its payment provider to charge the
        displayed renewal price to your nominated payment method at the end of
        each membership period. Each successful renewal starts a new 365-day
        membership period.
      </p>
      <p>
        <strong>Cancelling automatic renewal.</strong> You may cancel automatic
        renewal before the next payment through the available portal function or
        by contacting admin@icompetenatural.com. Cancellation stops the next
        renewal but does not end or refund the current membership, which remains
        active until its expiry date unless separately closed, refunded,
        suspended or terminated.
      </p>
      <p>
        If a renewal payment fails, ICN may notify you and allow you to update
        the payment method. Unless payment is successfully completed, the
        membership will expire at the end of the current period.
      </p>
      <h3>7. Membership refunds</h3>
      <p>
        A member may separately request a membership refund while the membership
        is active by emailing admin@icompetenatural.com. Account closure or
        cancellation of automatic renewal does not itself constitute a refund
        request.
      </p>
      <p>
        If the member has not competed in an ICN event during the current
        membership period, the amount paid for that membership will be refunded
        less an administration fee of A$35, or the equivalent amount in the
        currency in which the membership was paid. The refunded membership will
        then end.
      </p>
      <p>
        Once the member has competed in an ICN event during that membership
        period, the membership is considered used and is non-refundable. No
        refund is payable where membership is suspended or terminated because of
        a breach of these Terms, the ICN Rules, the Anti-Doping Policy or the
        Code of Ethics, except where applicable law requires otherwise.
      </p>
      <p>
        Membership refunds do not include event entry fees or other purchases,
        which are governed by the applicable event or purchase terms. Approved
        refunds will ordinarily be returned to the original payment method and
        may take additional time to appear depending on the member’s bank or
        payment provider. Nothing in this clause limits any non-excludable right
        or remedy under applicable consumer law.
      </p>
      <h3>8. Account closure</h3>
      <p>
        A member may separately request closure of their portal account. Closing
        an account does not constitute a refund request. Any automatic renewal
        will be cancelled, and ICN may retain historical competition,
        drug-testing, disciplinary and payment records where reasonably
        necessary or required by law.
      </p>
      <h3>9. ICN Rules and policies</h3>
      <p>
        Members must comply with the current ICN Rules &amp; Regulations,
        Eligibility Rule and Anti-Doping Policy, together with the Code of
        Ethics, conduct, content and safety standards in clauses 12 to 15 of
        these Terms. These requirements form part of the conditions of
        membership, portal use and participation. The membership and payment
        provisions in these Terms govern membership purchases; the more specific
        sporting, anti-doping or event rule governs the corresponding sporting
        or event matter.
      </p>
      <p>
        ICN may make reasonable changes to its sporting and anti-doping rules
        when necessary to protect safety, fairness, the integrity of natural
        competition, compliance with law or accepted testing standards. Current
        policies are made available through the portal or official ICN channels.
      </p>
      <h3>10. Drug-free eligibility and testing</h3>
      <p>
        <strong>Membership and eligibility are different.</strong> A person may
        purchase membership without first being approved to compete. To enter an
        ICN contest, an athlete must meet ICN’s competition eligibility
        requirements, including the applicable drug-free period. At the
        effective date of these Terms, entry requires at least five years
        drug-free, subject to the detailed Eligibility Rule and Anti-Doping
        Policy.
      </p>
      <p>
        <strong>ICN 365 testing.</strong> As a condition of membership, members
        agree that they may be selected for in-competition or out-of-competition
        testing while their membership is active and agree to comply with a
        valid request to provide a sample in accordance with the Anti-Doping
        Policy.
      </p>
      <p>
        <strong>Refusal and violations.</strong> Refusing or failing to comply
        with a valid testing request, returning a prohibited result, tampering
        with the process or otherwise breaching the Anti-Doping Policy may
        result in disqualification, suspension, lifetime ineligibility or other
        sanctions stated in the current policy. A sanction may apply even if the
        member has not competed during the current membership period.
      </p>
      <p>
        Drug-testing, therapeutic-use, medical and related information may be
        sensitive information. ICN will handle that information in accordance
        with its Privacy Policy, applicable collection notices and applicable
        law, including by sharing it where reasonably necessary with authorised
        ICN officials, collection personnel, laboratories and relevant sporting
        decision-makers.
      </p>
      <h3>11. Competition entry applications</h3>
      <p>
        Submitting an online entry is an application to compete. ICN reserves
        the right, under its Eligibility Rule, to refuse an entry application or
        withdraw an application before the athlete competes. A promoter may also
        refuse an application where authorised by the applicable ICN rule or
        event conditions.
      </p>
      <p>
        An entry decision may take account of eligibility, compliance, safety,
        capacity, event operation and the integrity of natural competition.
        Membership does not require ICN to accept an entry application or to
        prove an Anti-Doping Policy violation before making a
        competition-eligibility decision under the Eligibility Rule.
      </p>
      <p>
        If ICN or the promoter refuses or withdraws an entry application before
        the athlete competes, the entry fee paid for that application will be
        refunded by the party that received it. An entry refusal does not
        automatically cancel or refund membership; the member may make a
        separate refund request under clause 7 if eligible.
      </p>
      <h3>12. ICN Code of Ethics</h3>
      <p>
        The ICN Code of Ethics forms part of these Terms and applies whenever a
        member uses an ICN service or participates in an ICN activity. Every
        member agrees to:
      </p>
      <ul>
        <li>
          treat members, athletes, officials, volunteers, promoters and other
          participants with dignity and respect;
        </li>
        <li>
          provide accurate information to ICN, communicate honestly and not
          impersonate or knowingly mislead another person;
        </li>
        <li>
          respect privacy and confidentiality and not disclose private
          information, communications or images without permission, except where
          reasonably necessary to report a genuine safety, legal or integrity
          concern;
        </li>
        <li>
          protect their password and account, maintain only one personal account
          and not allow another person to use it;
        </li>
        <li>
          use the portal, member information and ICN communications only for
          legitimate personal and ICN-related purposes, without spam or
          unauthorised commercial solicitation;
        </li>
        <li>
          comply with applicable ICN rules and reasonable directions and not
          interfere with an event, judging, testing, investigation, sanction or
          portal system; and
        </li>
        <li>
          promptly and honestly report serious suspected safety, integrity or
          conduct breaches through the ICN Help Centre.
        </li>
      </ul>
      <h3>13. Member content and communications</h3>
      <p>
        Members are responsible for Content they submit, display or send through
        the portal. A member must have the rights and permissions needed to
        submit that Content and must not violate another person's privacy,
        confidentiality, intellectual-property or other legal rights.
      </p>
      <p>
        Content supplied by members, promoters or other third parties reflects
        the views or information of its author. ICN does not adopt or endorse it
        merely because it appears on the portal and cannot guarantee that it is
        complete, current or accurate. Members should not rely on another user's
        Content as medical, legal, financial or professional advice.
      </p>
      <p>
        Members must not publish another person's contact details or private
        information without permission and should not place their own sensitive
        contact details in publicly viewable areas not designed for that
        purpose. Members are responsible for retaining messages or Content they
        need to keep; ICN may be unable to retrieve deleted material.
      </p>
      <h3>14. Prohibited Content and portal misuse</h3>
      <p>
        A member must not submit, send, upload, link to or otherwise use the
        portal for Content or activity that:
      </p>
      <ul>
        <li>
          is unlawful, fraudulent or deceptive, or encourages or facilitates
          unlawful conduct;
        </li>
        <li>
          threatens, harasses, bullies, stalks or abuses another person, or
          promotes hatred or unlawful discrimination;
        </li>
        <li>
          is defamatory, pornographic, sexually exploitative, graphically
          violent, abusive or otherwise unsuitable for a general audience that
          may include members aged 15 to 17;
        </li>
        <li>
          impersonates another person or uses another person's image, identity,
          private information or intellectual property without authority;
        </li>
        <li>
          contains spam, unauthorised advertising, commercial solicitation,
          fundraising or recruitment;
        </li>
        <li>
          offers, sells or facilitates prohibited performance-enhancing
          substances or conduct contrary to ICN's natural-sport rules;
        </li>
        <li>
          contains malware, phishing, credential collection or other material
          intended to compromise a person, account, device or system; or
        </li>
        <li>
          scrapes or harvests member data, uses unauthorised automated access,
          creates duplicate or deceptive accounts, circumvents a restriction, or
          disrupts the portal.
        </li>
      </ul>
      <h3>15. Moderation, reporting and online safety</h3>
      <p>
        ICN may use manual review and automated tools to identify spam, security
        risks or possible breaches. Where ICN reasonably considers it necessary
        to enforce these Terms, protect a person, comply with law or maintain
        the portal, ICN may remove, hide, restrict or redact Content; limit
        messaging or profile visibility; preserve relevant records; or take
        action under clause 16.
      </p>
      <p>
        ICN does not undertake to monitor every profile, message or item of
        Content and cannot guarantee that objectionable material will be
        identified or removed immediately. Members should report suspected
        harassment, impersonation, unsafe Content or other serious breaches
        through the ICN Help Centre. ICN is not an emergency service; an
        immediate risk of harm should be reported to the appropriate local
        emergency service or authority.
      </p>
      <p>
        ICN is not required to arbitrate ordinary private disputes between
        members. It may nevertheless investigate and act where conduct involves
        the portal, an ICN activity, member safety, natural-sport integrity or a
        possible breach of these Terms. ICN may refer suspected unlawful conduct
        to an appropriate authority where permitted or required by law.
      </p>
      <h3>16. Suspension and termination by ICN</h3>
      <p>
        ICN may restrict portal access, suspend membership benefits, refuse
        participation or terminate membership where it reasonably considers this
        necessary because of a material or repeated breach of these Terms or an
        incorporated ICN policy; an anti-doping violation or failure to comply
        with testing; unlawful or abusive conduct; fraud or payment misuse; or a
        need to protect the safety or integrity of ICN activities or systems.
      </p>
      <p>
        ICN may take temporary action while a matter is investigated. Where
        appropriate and reasonably practicable, ICN will notify the member of
        the action and the general reason for it. Any review or appeal available
        under a specific ICN policy remains governed by that policy. Suspension
        or termination does not erase competition, testing, eligibility or
        disciplinary records.
      </p>
      <h3>17. Portal information, availability and third-party services</h3>
      <p>
        ICN takes reasonable care in publishing official portal information, but
        event dates, venues, schedules, divisions, prices, results, profile
        details, status icons and other information may change or may be
        supplied by a member, promoter or service provider. Members should check
        the applicable official rule, entry confirmation and event notice. A
        specific official rule or event notice prevails over a general portal
        summary to the extent of any inconsistency.
      </p>
      <p>
        ICN aims to keep the portal available and secure but does not promise
        uninterrupted or error-free access. Access may be limited temporarily
        for maintenance, security, upgrades, internet or provider failures,
        emergencies or events outside ICN’s reasonable control. ICN will take
        reasonable steps to restore affected services.
      </p>
      <p>
        The portal may use or link to third-party services, including payment
        providers, laboratories, media suppliers and independent event
        promoters. Their separate terms and privacy practices may apply. ICN
        remains responsible for its own obligations and does not exclude
        liability that cannot lawfully be excluded.
      </p>
      <h3>18. Intellectual property and member Content</h3>
      <p>
        The portal, ICN names and logos, software, layout and ICN-created
        materials are owned by or licensed to ICN and are protected by
        intellectual-property law. You may use portal content only for your
        personal, non-commercial participation in ICN, unless ICN gives written
        permission for another use. You must not copy, scrape, republish, sell,
        modify or exploit ICN content or branding without permission.
      </p>
      <p>
        You retain ownership of content you submit. You grant ICN a
        non-exclusive, royalty-free licence to store, reproduce, moderate and
        display that content only as reasonably necessary to operate the portal,
        provide the requested service, administer ICN activities and comply with
        law. This clause does not replace any separate event media release.
      </p>
      <h3>19. Privacy, profiles and sporting records</h3>
      <p>
        ICN handles personal information in accordance with its Privacy Policy
        and any collection notice provided when information is collected.
        Depending on the profile settings and purpose of collection, selected
        profile information may be visible to other portal users or the public.
      </p>
      <p>
        For security, fraud prevention, system administration and investigation
        of suspected misuse, ICN may collect and use technical information such
        as IP addresses, device information and successful or unsuccessful
        access records, as explained in the Privacy Policy.
      </p>
      <p>
        Members acknowledge that names, countries, divisions, event
        participation, placings, awards and other sporting results may be
        recorded and published as part of ICN’s historical sporting record.
        Anti-doping or disciplinary outcomes may be recorded or published where
        permitted by the applicable policy and law. ICN will take reasonable
        steps to protect the personal information it retains and to delete or
        de-identify information that it no longer reasonably needs, subject to
        applicable retention requirements.
      </p>
      <h3>20. Official communications</h3>
      <p>
        ICN may send service communications reasonably necessary to administer
        an account, membership, payment, entry, event, testing request, policy
        matter or security issue. Members are responsible for keeping their
        email address and mobile number current and for checking official ICN
        communications relevant to their participation.
      </p>
      <p>
        Marketing communications will be sent only where ICN has the required
        consent or another lawful basis. A recipient may unsubscribe from
        marketing using the method provided in the message. Unsubscribing from
        marketing does not prevent ICN from sending necessary non-marketing
        service communications.
      </p>
      <h3>21. Consumer rights and liability</h3>
      <p>
        Nothing in these Terms excludes, restricts or modifies any consumer
        guarantee, right or remedy that cannot lawfully be excluded, including
        rights under the Australian Consumer Law.
      </p>
      <p>
        To the maximum extent permitted by law, ICN is not liable for loss
        caused by circumstances outside its reasonable control, a member’s
        breach or unlawful conduct, inaccurate information supplied by a member,
        or the independent acts or omissions of a third party for whom ICN is
        not legally responsible. ICN is responsible for loss that applicable law
        requires it to bear.
      </p>
      <p>
        Information made available through the portal is general sporting or
        administrative information and is not medical, legal or financial
        advice. Members should obtain appropriate professional advice for their
        personal circumstances.
      </p>
      <h3>22. Changes to these Terms</h3>
      <p>
        ICN may update these Terms to reflect changes to its services, payment
        arrangements, sporting requirements or legal obligations. The current
        version and effective date will be published through the portal. ICN
        will provide reasonable notice of a material change where practicable.
        Changes will not retrospectively remove a right that has already accrued
        and will not limit any non-excludable legal right.
      </p>
      <p>
        A new membership or renewal is governed by the Terms presented at that
        purchase or renewal. Continued use of the portal after an updated
        version takes effect constitutes acceptance of the updated website-use
        provisions.
      </p>
      <h3>23. Complaints, governing law and general provisions</h3>
      <p>
        <strong>Contact and complaints.</strong> Questions, refund requests and
        complaints may be sent to admin@icompetenatural.com. ICN may request
        information reasonably necessary to identify the member and investigate
        the matter.
      </p>
      <p>
        <strong>Governing law.</strong> These Terms are governed by the laws of
        Victoria, Australia. The parties submit to the non-exclusive
        jurisdiction of the courts and tribunals of Victoria and any court
        competent to hear an appeal. Mandatory rights available to a member
        under the law of their location are not excluded where they lawfully
        apply.
      </p>
      <p>
        <strong>Severability.</strong> If part of these Terms is invalid or
        unenforceable, that part will be read down or severed to the extent
        necessary, and the remaining Terms will continue to operate.
      </p>
      <p>
        <strong>No waiver.</strong> A failure or delay by ICN in enforcing a
        right does not waive that right.
      </p>
      <p>
        <strong>Entire agreement.</strong> These Terms and the policies and
        event conditions expressly incorporated into them form the agreement
        concerning use of the portal and ICN membership. They do not exclude any
        representation or obligation that cannot lawfully be excluded.
      </p>
      <p>
        <strong>
          Natural Icons Pty. Ltd. | ABN 52 089 094 351 | trading as iCompete
          Natural
        </strong>
      </p>
    </div>
  );
};

export default TermsAndConditions;
